import React, { useEffect, useState } from 'react';

import Text from 'v3/components/Text';
import Loader from 'v3/components/Loader';

import { useSnackbar } from 'v3/components/Snackbar';

import api from 'services/api';

import * as Styled from './styles';
import { verifyMostAcessedPermissions } from './validator';

function MostAccessed() {
  const snackbar = useSnackbar();

  const [mostAccessed, setMostAccessed] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getUserMostAccessed() {
    setLoading(true);
    try {
      const response = await api.get(`v3/user/most-accessed`);

      validateMostAcessedPermission(response.data);
    } catch (err) {
      snackbar.show(<Text>Erro ao buscar seus mais acessados</Text>, {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  const validateMostAcessedPermission = mostAccessed => {
    const validAcessedRoutes = verifyMostAcessedPermissions(mostAccessed);
    setMostAccessed(validAcessedRoutes);
  };

  useEffect(() => {
    getUserMostAccessed();
  }, []);

  return (
    <>
      <Styled.AccessContainer>
        <Text
          color="primary"
          weight="700"
          fontSize="21.14px"
          className="mb-0"
        >
          Acesso rápido
        </Text>

        <Styled.ButtonsWrap>
          {!loading ? (
            mostAccessed.length > 0 ? (
              mostAccessed.map((accessed, index) => {
                return (
                  <Styled.LinkTo
                    href={accessed.path}
                    withoutIcon
                    to={`${accessed.path}`}
                    target="_blank"
                    key={`${accessed.path}-${index}`}
                  >
                    <Styled.BadgeLink
                      pill
                      outlined
                      variant="secondary"
                    >
                      <Styled.Title color="dark" weight="700">
                        {accessed.name}
                      </Styled.Title>
                    </Styled.BadgeLink>
                  </Styled.LinkTo>
                );
              })
            ) : (
              <Text>Não há mais acessados ainda!</Text>
            )
          ) : (
            <div className="d-flex justify-content-center">
              <Loader size="md" loading={loading} />
            </div>
          )}
        </Styled.ButtonsWrap>
      </Styled.AccessContainer>
    </>
  );
}

export default MostAccessed;
